import { DataTable } from "web/components"
import { useEffect, useRef } from "react"

export default function TileTableEditor({ tile, data, showDummyData }) {
  const {
    sort_field_key: sortField,
    second_group_field_key: secondGroupField,
    group_field_key: groupField,
  } = tile

  const sortDesc = tile.sort_direction === "DESC"
  const groupDesc = tile.group_direction === "DESC"
  const secondGroupDesc = tile.second_group_direction === "DESC"

  const columns = tile.fields.map((field, index) => ({
    id: field.tile_field_id,
    array_index: index,
    type: "data",
    label: field.label,
    fieldKind: field.kind,
    fieldFormat: field.format,
    width: field.column_width,
    dataKey: field.key,
    presentation: field.presentation,
  }))

  // use ref is required because the dom event handler needs the most recent version of it and will not get it if not used in a ref
  const currentTile = useRef(tile)
  useEffect(() => {
    currentTile.current = tile
  }, [tile])

  return (
    <div className="flex min-h-0 grow flex-col pl-3 md:pl-5">
      <DataTable
        columns={columns}
        data={showDummyData ? tile.getDummyTableData().detail : data.detail}
        onResizeColumn={(column, newWidth) =>
          tile.handleResizeColumn(column, newWidth, currentTile)
        }
        onMoveColumn={(fromColumn, toColumn) =>
          tile.handleMoveColumn(fromColumn, toColumn)
        }
        onSort={(column, direction) =>
          tile.handleSortChanged(column, direction)
        }
        onGroup={(column) => tile.handleGroupChanged(column)}
        sortColumn={sortField}
        sortDesc={sortDesc}
        groupColumn={groupField}
        groupDesc={groupDesc}
        secondGroupColumn={secondGroupField}
        secondGroupDesc={secondGroupDesc}
        itemLabel={tile.group_label}
        grandTotals={showDummyData ? [] : data.grand_totals}
        groupTotals={showDummyData ? [] : data.group_totals}
        showGrandTotals={tile.show_grand_totals}
        showGroupTotals={tile.show_group_totals}
        showDetails={tile.show_details}
        showEmptyTable
        groupCollection={
          showDummyData ? tile.getDummyGroupCollection() : data.group_collection
        }
      />
    </div>
  )
}
